<!-- eslint-disable -->
<template lang="pug">
    div.image-input
        crop-image-modal(
            v-if="crop && displayCropImageModal",
            :image="image",
            @close="closeCropImage",
            @cropImage="cropImageReady"
        )
        input.image-input__input-area(
            type="file",
            id="file-select",
            :accept="accept.join(',')",
            @change="input",
            ref="fileSelect"
        )
        label.image-input__body(for="file-select", @click="deleteImage")
            div.image-input__image-block
                img.image-input__image(
                    :src="image ? image : defaultImage",
                    :alt="imageAlt"
                )
            div.image-input__text
                div.image-input__link {{ (image && !image.match(/no-photo.svg/) ) ? removeText : loadText }}
                div.image-input__help-text {{ helpText }}
        help-text(v-if="error", error) {{ error }}
</template>

<script>
    /*eslint-disable*/
    const cropImageModal = () => import("./CropImageModal.vue")
    import HelpText from "../HelpText.vue"

    const MAX_IMAGE_SIZE = 2

    /**
     * ImageInputs are used to upload images.
     */
    export default {
        model: {
            prop: "image",
            event: "input",
        },
        name: "ImageInput",
        status: "ready",
        release: "1.0.0",
        props: {
            /**
             * Type of files that can be used in image-input
             */
            accept: {
                type: Array,
                default: () => ["image/jpeg", "image/png", "image/gif", "image/bmp"],
            },
            /**
             * Value of image-input.
             */
            image: {
                type: String,
                default: null,
            },
            /**
             * Default image which will be showed when 'image' is null
             */
            defaultImage: {
                type: String,
                required: true,
            },
            /**
             * Text to render before image is loaded.
             */
            imageAlt: {
                type: String,
                default: "Image is loading",
            },
            /**
             * Text for loading image.
             */
            loadText: {
                type: String,
                default: "Загрузить изображение",
            },
            /**
             * Text for removing image.
             */
            removeText: {
                type: String,
                default: "Удалить изображение",
            },
            /**
             * Note about file can be uploaded.
             */
            helpText: {
                type: String,
                default: "JPG, PNG, GIF не более 2 Мб",
            },
            /**
             * Error state of input.
             */
            error: {
                type: String,
                default: null,
            },
            /**
             * Property to disable cropper if needed.
             */
            crop: {
                type: Boolean,
                default: true,
            },
        },
        data() {
            return {
                displayCropImageModal: false,
            }
        },
        methods: {
            deleteImage(event) {
                if (this.image && !this.image.match(/no-photo.svg/)) {
                    event.preventDefault()
                    this.discardAvatar()
                }
            },
            input(e) {
                let files = e.target.files || e.dataTransfer.files
                if (!files.length) {
                    return
                }
                let fileReader = new FileReader()
                fileReader.onload = e => {
                    let uint = new Uint8Array(e.target.result)
                    let bytes = uint.reduce((accumulator, byte) => {
                        accumulator.push(byte.toString(16))
                        return accumulator
                    }, [])
                    let hex = bytes.join("").toUpperCase()
                    let MIMEType = this.getMimeType(hex)
                    if (this.accept.includes(MIMEType)) {
                        this.createImage(files[0])
                    } else if (files[0].type === MIMEType) {
                        this.$emit("showTypeError")
                    } else {
                        this.$emit("showFileError")
                    }
                }

                fileReader.readAsArrayBuffer(files[0].slice(0, 4))
            },
            getMimeType(signature) {
                switch (signature) {
                    case "89504E47":
                        return "image/png"
                    case "47494638":
                        return "image/gif"
                    case "25504446":
                        return "application/pdf"
                    case "FFD8FFDB":
                    case "FFD8FFE0":
                    case "FFD8FFE1":
                        return "image/jpeg"
                    case "504B0304":
                        return "application/zip"
                    default:
                        return "Unknown FileType"
                }
            },
            createImage(file) {
                let imageSizeInMb = (file.size / 1048576).toFixed(2)
                if (imageSizeInMb > MAX_IMAGE_SIZE) {
                    this.$emit("showSizeError")
                    return
                }
                let reader = new FileReader()
                reader.onload = e => {
                    this.$emit("input", e.target.result)
                    this.displayCropImageModal = true
                }
                reader.readAsDataURL(file)
            },
            cropImageReady(base64data) {
                this.$emit("input", base64data)
                this.displayCropImageModal = false
            },
            closeCropImage() {
                this.displayCropImageModal = false
                this.discardAvatar()
            },
            discardAvatar() {
                this.$refs.fileSelect.value = ""
                this.$emit("input", null)
            },
        },
        components: {
            HelpText,
            cropImageModal,
        },
    }
</script>

<style lang="scss" scoped>
    $link-font-size: $font-size-16;
    $help-text-font-size: $font-size-16;
    $inline-space: 8px;

    .image-input {
        @include stack-space($space-small);
        width: 100%;
        display: flex;
        flex-direction: column;
    }

    .image-input__input-area {
        display: none;
    }

    .image-input__body {
        display: inline-flex;
        cursor: pointer;
        @include stack-space($space-x-small);
        align-items: center;
        &:hover {
            .image-input__link {
                text-decoration: underline;
            }
        }
    }
    .image-input__image-block {
        @include inline-space($space-large);
        display: flex;
        align-items: center;
        justify-content: center;
        overflow: hidden;

        border: 1px solid $hsl-color-gray-74;
        border-radius: $border-radius-circle;
        background-color: $x-color-white;

        height: 60px;
        width: 60px;
        @include media($xlg) {
            height: 100px;
            width: 100px;
        }
    }

    .image-input__image {
        max-height: 100%;
    }

    .image-input__link {
        font-size: $link-font-size;
        line-height: 26px;
        @include stack-space($inline-space);
        color: $hsl-color-blue-56;
        text-decoration: underline;
        &:hover {
            color: $hsl-color-blue-56;
            text-decoration: none;
        }
    }

    .image-input__help-text {
        font-size: $link-font-size;
        line-height: 19px;
        color: $hsl-color-gray-53;
    }
</style>
